import { IAttachmentType } from "../../attachmentType/model/AttachmentType";
import AttachmentTypeMapper from "../../attachmentType/service/AttachmentTypeMapper";
import GetAllResourceEntriesInteractor from "../../core/interactor/app/crud/GetResourceEntriesInteractor";
import Constants from "../common/Constants";
import AttachmentTypeParamMapper from "../../attachmentType/service/AttachmentTypeParamMapper";

export default class GetAllOrganisationAttachmentTypesInteractor {
  private resource: GetAllResourceEntriesInteractor<IAttachmentType>;

  constructor({ getAllResourceEntries }: any) {
    this.resource = getAllResourceEntries;
  }

  async execute(organisationId: number) {
    return this.resource.execute(
      `${Constants.organisationsPath}/${organisationId}/${Constants.attachmentTypePath}`,
      AttachmentTypeMapper,
      AttachmentTypeParamMapper
    );
  }
}
